import React from "react";
import stringTemplate from "./templates/string";
import checkboxTemplate from "./templates/checkbox";
import selectTemplate from "./templates/select";
import ratioTemplate from "./templates/radio";
import phoneTemplate from "./templates/phone";
import arrayTemplate from "./templates/array";
import numberTemplate from "./templates/number";
import dateTemplate from "./templates/date";
import enumTemplate from "./templates/enum";
import sliderTemplate from "./templates/slider";
import Box from "@mui/material/Box";
import moment from "moment";
import {addNullForEmptyField} from "../../services/helper";

export const renderForm = (data, key) => {
    switch (data.type) {
        case 'radio':
            return (ratioTemplate(data, key));
            break;
        case 'date':
            return (dateTemplate(data, key));
            break;
        case 'checkbox':
            return (checkboxTemplate(data, key));
            break;
        case 'select':
            return (selectTemplate(data, key));
            break;
        case 'array':
            return (arrayTemplate(data, key));
            break;
        case 'enum':
            return (enumTemplate(data, key));
            break;
        case 'number':
            return (numberTemplate(data, key));
        case 'string':
            return (stringTemplate(data, key));
        case 'phone':
            return (phoneTemplate(data, key));
        case 'slider':
            return (sliderTemplate(data, key));
        default:
            return (<Box>Did not found type of component</Box>);
    }
}


export const updateInfo = (columns, data) => {
    const obj = {};
    columns.forEach((column) => {
        switch (column.type) {
            case 'date':
                let formatted = moment(data.get(column.name), 'MM/DD/YYYY');

                if(!column.momentObj){
                    formatted = formatted.format( 'DD.MM.YYYY')
                }

                obj[column.name] = formatted;
                break;
            case 'phone':
                obj[column.name] = column.value;
            case 'array':
                obj[column.name] = column.value;
            case 'checkbox':
                obj[column.name] = column.value;
                break;
            case 'enum':
                obj[column.name] = data.get(column.name);
                break;
            case 'number':
                obj[column.name] = parseInt(data.get(column.name));
                break;
            default:
                obj[column.name] = data.get(column.name);
        }
    })

    addNullForEmptyField(obj);

    return obj;
}
